import React, { useState } from 'react';

export function useForm(initValues, validateOnChange = false, validate) {
    const [varValues, setValues] = useState(initValues);
    const [varErrors, setErrors] = useState({});

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...varValues,
            [name]: value,
        });

        if (validateOnChange) {
            validate({ [name]: value });
        }

        setErrors({
            ...varErrors,
            [name]: null,
        });
    };

    const resetForm = () => {
        setValues(initValues);
        setErrors({});
    };

    return {
        varValues,
        setValues,
        varErrors,
        setErrors,
        resetForm,
        handleInputChange,
    };
}

export function Form(props) {
    const { children, ...other } = props;
    return (
        <form autoComplete="off" {...other}>
            {props.children}
        </form>
    );
}
